document.addEventListener("DOMContentLoaded", function() {
      // This code will run when the document is fully loaded and ready
      var headerWrapper = document.getElementById("HeaderWrapper");

      /* headerWrapper.addEventListener("mouseover", function() {
        headerWrapper.classList.remove("is-light");
      }); */

        /*
       headerWrapper.addEventListener("mouseleave", function() {
        headerWrapper.classList.add("is-light");
      });
        */
      
    });
